<div class="page-layout simple fullwidth mat-white-bg" fusePerfectScrollbar>
    <app-basic-page [ngClass]="alias"></app-basic-page>
</div>
